import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { InventoryMePage } from '@/features/inventory'

export const Route = createFileRoute('/_authenticated/inventory/me')({
  component: () => (
    <RequirePermission permission='inventory_requests.create'>
      <InventoryMePage />
    </RequirePermission>
  ),
})
